<div style="display: flex;"
     [ngStyle]="{'justify-content': flexAlign()}">
    <span [innerHTML]="loaningSvc.getChipButton(loaning)"></span>
</div>
